import React from "react";

// Measure icon: an angle (baseline + diagonal ray + arc) with a "?" — recreated as a
// stroke-based SVG from the provided PNG so it recolors with the theme (active/inactive)
// and stays crisp at any size, exactly like the other toolbar tool icons.
const MeasureAngle = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    {/* baseline */}
    <line x1="5" y1="19" x2="21" y2="19" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
    {/* diagonal ray from the vertex */}
    <line x1="5" y1="19" x2="10.5" y2="4.5" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
    {/* arc showing the angle at the vertex */}
    <path d="M7.8 11.5 A 8 8 0 0 1 13 19" stroke={color} strokeWidth="1.4" strokeLinecap="round" fill="none" />
    {/* question mark */}
    <text x="15" y="12.5" fontFamily="Arial, Helvetica, sans-serif" fontSize="10" fontWeight="700" fill={color}>?</text>
  </svg>
);

export default MeasureAngle;